module.exports = __webpack_public_path__ + "img/3.46a9e3e2.svg";